import { Component, EventEmitter, Input, OnInit, OnDestroy, Output } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { NavListItem } from '../../models/navListItem';

@Component({
  selector: 'app-nav-list-item',
  templateUrl: './nav-list-item.component.html',
  styleUrls: ['./nav-list-item.component.scss'],
})
export class NavListItemComponent implements OnInit, OnDestroy {
  constructor(private router: Router) {
    this.routeListener = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.isCurrentPath = this.link.to === event.url;
      }
    });
  }

  @Input('config') link: NavListItem;
  @Output() open: EventEmitter<any> = new EventEmitter();

  isCurrentPath: boolean;
  routeListener: Subscription;

  ngOnInit(): void {
    this.router.events.subscribe(value => {
      this.isCurrentPath = this.link.to === this.router.url.toString();
    });

    // determine if the link is an external link
    this.link.external = this.link.to.startsWith('http');
    // if the link is external and no icon is set, let's set one
    if (this.link.external && !this.link.icon) {
      this.link.icon = 'fas fa-external-link';
    }
  }

  ngOnDestroy(): void {
    this.routeListener.unsubscribe();
  }

  emitClick(data?: any): void {
    this.open.emit(data);
  }
}
